export default function ChevronRight() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8.925" height="5.657" viewBox="0 0 8.925 5.657">
            <path id="Path_155" data-name="Path 155" d="M12.219,15,7.757,10.757,9.245,9.343l2.974,2.829,2.974-2.829,1.488,1.414Z" transform="translate(-7.757 -9.343)" fill="#fff"/>
        </svg>
    )
}